import { render } from "./VsolGponTable.vue?vue&type=template&id=a8ee4b9c&scoped=true"
import script from "./VsolGponTable.vue?vue&type=script&lang=js"
export * from "./VsolGponTable.vue?vue&type=script&lang=js"

import "./VsolGponTable.vue?vue&type=style&index=0&id=a8ee4b9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ee4b9c"]])

export default __exports__